import { configureStore } from '@reduxjs/toolkit';
import styleReducer from './styleSlice';
import mainReducer from './mainSlice';
import authSlice from './authSlice';
import openAiSlice from './openAiSlice';

import usersSlice from "./users/usersSlice";
import rolesSlice from "./roles/rolesSlice";
import permissionsSlice from "./permissions/permissionsSlice";
import projectsSlice from "./projects/projectsSlice";
import conversationsSlice from "./conversations/conversationsSlice";
import messagesSlice from "./messages/messagesSlice";
import templatesSlice from "./templates/templatesSlice";
import deploymentsSlice from "./deployments/deploymentsSlice";
import featuresSlice from "./features/featuresSlice";
import app_settingsSlice from "./app_settings/app_settingsSlice";

export const store = configureStore({
  reducer: {
    style: styleReducer,
    main: mainReducer,
    auth: authSlice,
    openAi: openAiSlice,

users: usersSlice,
roles: rolesSlice,
permissions: permissionsSlice,
projects: projectsSlice,
conversations: conversationsSlice,
messages: messagesSlice,
templates: templatesSlice,
deployments: deploymentsSlice,
features: featuresSlice,
app_settings: app_settingsSlice,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
